module.exports = __webpack_public_path__ + "img/nav-dots.24f0f4b3.svg";